import Animation from './Animation';
import './EnemyDie.css';
import fadeDeathClone from './deathClone';

export default class MinionsDie extends Animation {

	constructor (master, enemies) {

		super(master, 1800, true);
		this.enemies = enemies;
	}

	run () {

		this.enemies.forEach(enemy => {
			const entity = document.querySelector("#game-entity-" + enemy.id.no);
			fadeDeathClone(entity, this.time);
		});
		this.async();
	}
}
